import { render } from "./ETemplate.vue?vue&type=template&id=6206d7f2"
import script from "./ETemplate.vue?vue&type=script&lang=js"
export * from "./ETemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__